<template>
  <b-modal
    title="Rota estática"
    id="view_static_route"
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <b-form @submit.prevent="evOnSubmit">
      <warning-required-fields />
      <errors-messages :errors="errors" />
      <b-row>
        <b-col>
          <label-required-field label="Rota" />
          <b-input ref="autofocus" v-model="url" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>Versão</label>
          <b-input readonly v-model="version" />
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn
            class="v-primary ml-1"
            @click="$bvModal.hide('view_static_route')"
          >
            <i class="fa fa-arrow-left mr-1" /> VOLTAR
          </v-btn>
          <v-btn class="v-danger ml-1" @click="remove">
            <i class="fa fa-trash mr-1" /> REMOVER
          </v-btn>
          <v-btn type="submit" class="v-success ml-1">
            <i class="fa fa-save mr-1" /> SALVAR
          </v-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import toast from "../../components/ToastNotification";
import api from "../../services/api";
import ErrorsMessages from "../components/ErrorsMessages.vue";
import LabelRequiredField from "../components/LabelRequiredField.vue";
import WarningRequiredFields from "../components/WarningRequiredFields.vue";

export default {
  name: "ViewStaticRoute",
  components: {
    WarningRequiredFields,
    ErrorsMessages,
    LabelRequiredField,
  },
  props: {
    static_route_id: [String, Number],
  },
  data() {
    return {
      errors: [],
      loading: false,

      url: "",
      version: "",
    };
  },
  methods: {
    async evOnShow() {
      this.errors = [];
      this.url = "";
      this.version = "";
    },

    async evOnShown() {
      await this.retrieve();
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async evOnSubmit() {
      this.loading = true;

      try {
        const data = {
          id: this.static_route_id,
          url: this.url,
        };
        const response = await api.patch("/admin/rest-home/static-route", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("view_static_route");
          this.$emit("updated");
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },

    async remove() {
      this.loading = true;

      const params = {
        id: this.static_route_id,
      };
      const response = await api.delete("/admin/rest-home/static-route", {
        params,
      });
      const { error, errors, message } = response.data;

      if (error) {
        this.errors = errors;
      } else {
        this.errors = [];
        toast(message, "success");
        this.$bvModal.hide("view_static_route");
        this.$emit("updated");
      }

      this.loading = false;
    },

    async retrieve() {
      this.loading = true;

      try {
        const params = {
          id: this.static_route_id,
        };
        const response = await api.get("/admin/rest-home/static-route", {
          params,
        });
        const { error, errors, static_route } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.url = static_route.url;
          this.version = static_route.version;
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },
  },
};
</script>

<style>
</style>